import { useMemo } from "react";

import type { DatasetResource } from "@prequel/import-react";
import { useListDatasets } from "@prequel/import-react";
import { Status, StatusLight, type TableRow } from "@prequel/shared-components";

import { useAllProviders } from "@/api/import/providers";
import { useAllSources } from "@/api/import/sources";
import ResourceTable from "@/components/ResourceTable";
import Timestamp from "@/components/Timestamp";

const COLUMNS = ["Name", "Provider", "Source", "Status", "Created"];

const DatasetsTable = () => {
  const { items: providers } = useAllProviders();
  const { items: sources } = useAllSources();

  const providersByID = useMemo(() => new Map(providers.map((provider) => [provider.id, provider])), [providers]);
  const sourcesByID = useMemo(() => new Map(sources.map((source) => [source.id, source])), [sources]);

  const rowMapper = (dataset: DatasetResource): TableRow => ({
    id: dataset.id,
    to: `/import/datasets/${dataset.id}`,
    cells: [
      { value: dataset.name },
      { value: providersByID.get(dataset.provider_id)?.name ?? "-" },
      { value: sourcesByID.get(dataset.source_id)?.name ?? "-" },
      {
        value: (
          <span className="flex items-center gap-2">
            <StatusLight status={dataset.is_enabled ? Status.ACTIVE : Status.INACTIVE} />
            {dataset.is_enabled ? "Enabled" : "Disabled"}
          </span>
        ),
      },
      { value: <Timestamp timestamp={dataset.created_at} /> },
    ],
  });

  return (
    <ResourceTable<DatasetResource>
      columns={COLUMNS}
      useQuery={useListDatasets}
      rowMapper={rowMapper}
      emptyMessage="No datasets configured."
    />
  );
};

export default DatasetsTable;
